/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Cancellation_Page_Meta_DescriptionInputs */

const de_subscription_cancellation_page_meta_description = /** @type {(inputs: Subscription_Cancellation_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigen Sie Ihren waipu.tv Vertrag online.`)
};

/** @type {(inputs: Subscription_Cancellation_Page_Meta_DescriptionInputs) => LocalizedString} */
const en_subscription_cancellation_page_meta_description = de_subscription_cancellation_page_meta_description;

/**

* @param {Subscription_Cancellation_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const subscription_cancellation_page_meta_description = /** @type {((inputs?: Subscription_Cancellation_Page_Meta_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Cancellation_Page_Meta_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_subscription_cancellation_page_meta_description(inputs)
	return en_subscription_cancellation_page_meta_description(inputs)
});